import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'

import Steps from './steps'
import ProgressBar from './components/ProgressBar'
import TabPanel from './components/TabPanel'

import FormDataHandler from './functions/FormDataHandler'

import { useStyles } from './Container.styles'
import { testFormSubmit } from './functions/testDataSubmission'
import { testTokenizerSubmit } from './functions/testCreditCardTokenizer'
import { stateList, cardTypes } from './enums'

const trackBtnClick = () => {
  let src =
    '//pixel.quantserve.com/pixel/p-u64L5wy1qy35w.gif?labels=_fp.event.Thrifty Blue Chip Become a Member Submit Button Click'
  if (siteCountry === 'au') {
    src =
      '//pixel.quantserve.com/pixel/p-qK8G7WdP60WA4.gif?labels=_fp.event.Thrifty Blue Chip Become a Member Submit Button Click AU'
  }

  // let imgTag = document.createElement('img')
  // imgTag.src = src
  // document.body.appendChild(imgTag)
}

export const BlueChipFormContainer = ({
  isPromoForm,
  isPanelForm,
  setNewMemberNumber,
  setFormStatus,
}) => {
  const classes = useStyles()
  const dataHandler = new FormDataHandler()

  const [activeTab, setActiveTab] = useState(0)
  const [formData, setFormData] = useState({ 0: {}, 1: {}, 2: {} })

  const [formError, setFormError] = useState([])
  const [tabStatus, setTabStatus] = useState({
    0: 'incomplete',
    1: 'incomplete',
    2: 'incomplete',
  })
  const [countryList, setcountryList] = useState([])
  const [siteCountry, setSiteCountry] = useState('nz')

  const { regions } = useSelector(state => state.models.regions)

  useEffect(() => {
    setcountryList(regions)
    setSiteCountry(window.location.hostname.includes('.nz') ? 'nz' : 'au')
  }, [regions])

  const storeFormData = (formIndex, data) => {
    setFormData({
      ...formData,
      [formIndex]: data,
    })

    setTabStatus({
      ...tabStatus,
      [formIndex]: 'complete',
    })

    if (formIndex < 2) {
      // Move to next tab unless we're on the final tab
      changeTabs('next', formIndex)
      return
    }

    dataHandler.sendFormData(formData, function(response) {
      if (response.success) {
        setNewMemberNumber(response.data.newUserId)
        setFormStatus('complete')

        dataHandler.sendEmailSubscription(
          formData[0].email,
          response.data.newUserId,
          formData[0].firstName,
          isPromoForm,
        )

        const formHeaderContainer = document.getElementById('blue-chip-form-header')
        formHeaderContainer.scrollIntoView()
      } else {
        setFormError(response.data.content)
        setFormStatus('in-progress')

        const formContainer = document.getElementById('blue-chip-form-container')
        formContainer.scrollIntoView()
      }
    })
  }

  const changeTabs = (direction, index) => {
    if (direction == 'prev' && index != 0) setActiveTab(index - 1)
    if (direction == 'next' && index != 2) setActiveTab(index + 1)
    if (!direction) setActiveTab(index)

    const formContainer = document.getElementById('blue-chip-form-container')
    formContainer.scrollIntoView()
  }

  const panels = [
    { id: '1', key: 'tab-panel-0' },
    { id: '2', key: 'tab-panel-1' },
    { id: '3', key: 'tab-panel-2' },
  ]

  return (
    <div className={`${classes.formContainer} ${isPanelForm ? 'blue-bg' : 'white-bg'}`}>
      <ProgressBar
        activeTab={activeTab}
        tabStatus={tabStatus}
        changeTabs={changeTabs}
        isPanelForm={isPanelForm}
      />

      <button onClick={() => testFormSubmit(formData, setFormError, setFormStatus)}>
        Test Submission
      </button>
      <button onClick={() => testTokenizerSubmit(formData, setFormError, setFormStatus)}>
        Test Tokenization
      </button>

      {panels.map(({ id, key }, index) => {
        const Component = Steps[id]
        return (
          <TabPanel value={activeTab} index={index} key={key}>
            <Component
              formIndex={index}
              formError={formError}
              formData={formData[index]}
              storeFormData={storeFormData}
              changeTabs={changeTabs}
              stateList={stateList}
              countryList={countryList}
              cardTypes={cardTypes}
              siteCountry={siteCountry}
              isPanelForm={isPanelForm}
              isPromoForm={isPromoForm}
              showCCfields={false}
            />
          </TabPanel>
        )
      })}
    </div>
  )
}

export default BlueChipFormContainer
